export enum GarmentTechnology {
  Dtg = 'dtg',
  Embroidery = 'embroidery',
}
